import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  title: {
    marginBottom: '$space4',
    color: '$colorTextMedium',
    textAlign: 'center',
  },
  imgs: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  apple: {
    height: 43,
    width: 128,
    top: 0,
    left: 0,
    marginRight: 8,
  },
  android: {
    height: 43,
    width: 144,
    top: 0,
    left: 0,
  },
});
